import { FCM } from '@capacitor-community/fcm';
import api from '@/services/apiService';
import { getNativePlatform } from '@/utils/capacitor';

interface RegisterTokenPayload {
  fcm_token: string;
  platform: string;
  user_id?: number | null;
}

export async function resolveNativeFcmToken(nativeRegistrationToken: string): Promise<string> {
  if (getNativePlatform() !== 'ios') {
    return nativeRegistrationToken;
  }

  const result = await FCM.getToken();
  if (!result.token) {
    throw new Error('Empty FCM token from native plugin');
  }
  return result.token;
}

export async function registerFcmToken(fcmToken: string, userId?: number | null): Promise<void> {
  const payload: RegisterTokenPayload = {
    fcm_token: fcmToken,
    platform: getNativePlatform(),
    user_id: userId ?? null,
  };
  await api.post('/tokens/register', payload);
}
